import { render, staticRenderFns } from "./SettingTheme.vue?vue&type=template&id=168af152"
import script from "./SettingTheme.vue?vue&type=script&lang=js"
export * from "./SettingTheme.vue?vue&type=script&lang=js"
import style0 from "./SettingTheme.vue?vue&type=style&index=0&id=168af152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports